import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m13.182 14.9-5.424 6.424c-.243.243-.901.63-1.25.676h-3c-.75.101-1.6-1.25-1.5-2v-2c.13-.97 1-2 2-2 .415 0 .429-.174.469-.659l.012-.149q.018-.193.083-.375c.464-1.268 1.08-1.633 2.219-1.79a.38.38 0 0 0 .298-.23c.084-.21.125-.622.152-.894l.011-.107.032-.292a.5.5 0 0 1 .02-.1c.158-.504.347-.665.704-.904a5.7 5.7 0 0 1 1.363-.676c.46-.165.637-.229.637-.824-.5-2 .326-4.326 1.5-5.5 2.737-2.737 7.14-1.86 9 0 2 2 2.737 6.06 0 8.796-1.644 1.645-3.751 2.01-5.25 1.884-.765-.065-1.58.133-2.076.72m2.826-8.4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_key_filled-Ds3USZMn.js.map
